<template>
  <div class="fj-warp d-f fd-c jc-sb bgc-fff fs-18 ff-roboto">
    <FjNavBar />
    <AppMain />
    <FjFooter></FjFooter>
    <Modal v-model="showModal" :closable="false" fullscreen footer-hide title="Fullscreen Modal">
      <!-- <div>This is a fullscreen modal</div> -->
      <!-- <Input v-model="value1" size="large" placeholder="large size" /> -->
      <Input search enter-button="确定" v-model="value" placeholder="Enter something..." @on-search="handleModal" />
    </Modal>
  </div>
</template>

<script>
  // import { mapState } from 'vuex'
  // import { mapMutations, mapState } from 'vuex'
  import AppMain from '@/components/LayoutsCom/AppMain.vue'
  import FjFooter from '@/components/LayoutsCom/FjFooter.vue'
  import FjNavBar from '@/components/LayoutsCom/FjNavBar.vue'

  export default {
    components: {
      AppMain,
      FjNavBar,
      FjFooter
    },
    data() {
      return {
        showModal: true,
        value: ''
      }
    },
    // 页面路由跳转
    // middleware({ app, redirect, store }) {
    //   // If the user is not authenticated
    //   if (process.server && store.state.userIp) {
    //     return app.$api.homeApi.queryIpInfo(store.state.userIp).then((data) => {
    //       // 中国ip直接跳转到对应的网站
    //       if (data.startsWith('中国')) {
    //         // 跳转到非状态页面
    //         return redirect('https://www.fjdynamics.cn')
    //       }
    //     })
    //   }
    // },

    computed: {
      // ...mapState(['isShowMenu', 'isNavAnchor', 'isScrollAnchor'])
      // 判断是否激活状态 控制三个状态
      // 1. 首页的滚动
      // 决定是否存在Anchor
      // isIndexPahe() {
      //   return this.$route.name.startsWith('index___')
      // }
      // isHomePage() {
      //   return this.$route.name.startsWith('index__')
      // }
    },
    mounted() {
      this.value = localStorage.getItem('value') || ''
      this.showModal = this.value !== 'fj666'
      // console.log(this.$store.state.userIp, 'store.state.userIp')
      // 全局通用配置
      // this.$aos.init({
      //   offset: 120,
      //   duration: 500,
      //   easing: 'ease',
      //   delay: 0
      // })
      // 清楚全局的cookie
      // window.addEventListener('beforeunload', () => {
      //   this.$cookies.removeAll()
      // })
      // // 滚动事件
      // window.scrollTo({ top: 0 }, { behavior: 'instant' })
      // // 当前是首页， 滚动时候的样式
      // window.addEventListener('scroll', this.handleScroll)
      // // 首次进入的时候
      // this.handleScroll()
    },
    methods: {
      handleModal() {
        if (this.value === 'fj666') {
          this.showModal = false
          localStorage.setItem('value', this.value)
        }
      }
      // ...mapMutations(['changeNavAnchor', 'showModalMenu', 'scrollNavAnchor']),
      // handleScroll() {
      //   // 初次进去的时候
      //   // 当前为是激活的 滚动的时候不变色
      //   if (!this.isHomePage) {
      //     // 非首页初次进去的时候
      //     this.changeNavAnchor(true)
      //   }
      //   // 是首页 未打开的状态 滑动的时候进行变色
      //   const menuHeight = 76
      //   const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      //   const clientHeight = document.documentElement.clientHeight
      //   const isShowAnchor = scrollTop + menuHeight >= clientHeight
      //   // 滚动超过的距离
      //   this.scrollNavAnchor(isShowAnchor)
      // }
    }
  }
</script>

<style lang="scss" scoped>
  .fj-warp {
    min-height: 100vh;
  }
  .mt-nav {
    margin-top: 0.75rem;
  }
</style>
